<template>
  <div class="poi">
    <!-- <img :src="img" alt="" srcset=""> -->
    <div id="top">
      <div class="top top1">正常状态</div>
      <div class="top top2"></div>
      <div class="top top3">中度告警</div>
      <div class="top top4"></div>
      <div class="top top5">重度告警</div>
      <div class="top top6"></div>
    </div>
    <valstatus v-for="(item,index) in val" class="mt" :info="item" :key="index" />
    
  </div>
</template>

<script>
// import img from "../img/p2.png";
import valstatus from "../valstatus/icon2.vue";
// import cfg from "./config.js";
export default {
  components: { valstatus },
  props: ["datainfo"],
  mounted() {
    let val = []
    for (let index = 0; index < this.datainfo.data[0].listObjects[0].data.length; index++) {
      val.push({ key: this.datainfo.data[0].listObjects[0].data[index].column, vals: this.datainfo.data[0].listObjects[0].data[index].values })
    }
    this.val = val
  },
  data() {
    return {
      // img,
      val: [],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.poi {
  padding-top: 0.1rem;
}
.mt {
  margin-bottom: 0.1rem;
  // overflow: hidden;
}
#top {
  overflow: hidden;
  width: 100%;
  pointer-events: none;
  display: flex;
  justify-content: space-between;
}
.top {
  float: left;
  color: #0f69ca;
  font-size: 0.07rem;
  line-height: 0.15rem;
  margin-bottom: 0.05rem;
  white-space: nowrap;
}
.top:nth-child(2n + 1) {
  // width: 0.4rem;
  // margin-right: 0.05rem;
}
.top:nth-child(2n) {
  // margin-right: 0.1rem;
  width: 0.15rem;
  height: 0.15rem;
  font-size: 0.01rem;
  background-size: 100% 100%;
  background-position: 50% 50%;
}
.top2 {
  background: url(../img/green.png);
}
.top4 {
  background: url(../img/yellow.png);
}
.top6 {
  background: url(../img/red.png);
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/data/cuwarning.vue